import {
  AgronomistDueData,
  OverdueStatusPropertiesKey,
  overdueStatusProperties,
} from '../helper';

type DueStatusBarProps = {
  due: Due;
  totalBalance: number;
};

type Due = AgronomistDueData['agronomistDueStatus'][number];

const DueStatusBar = ({ due, totalBalance }: DueStatusBarProps) => {
  const percentage = (due.remainingBalance / totalBalance) * 100;
  return (
    <div
      className={`due-status-bar ${overdueStatusProperties[due.dueStatus as OverdueStatusPropertiesKey].color}`}
      style={{
        width: `${percentage < 1 ? 1 : percentage.toFixed(0)}%`,
      }}
    />
  );
};

export default DueStatusBar;
